import { DATE_FORMAT_DATE } from "@/schemas/question/date-formats";
import { FILE_TYPE_PHOTO } from "@/schemas/question/file-types";
import { VALIDATION_EMPTY } from "@/schemas/question/validation";
import { VISUALIZATION_HORIZONTAL } from "@/schemas/question/visualization";
import {
  Checkbox,
  Datehour,
  File,
  Input,
  Pictures,
  Radio,
  Select,
  Textarea,
} from "@/types/question";

export const input: Input = {
  validation: VALIDATION_EMPTY,
  minLength: 0,
  maxLength: 0,
};

export const textarea: Textarea = {
  minLength: 0,
  maxLength: 0,
};

export const radio: Radio = {
  visualization: VISUALIZATION_HORIZONTAL,
  variants: [{ variant: "" }, { variant: "" }],
};

export const datehour: Datehour = {
  type: DATE_FORMAT_DATE,
};

export const pictures: Pictures = {
  minQuantity: 0,
  maxQuantity: 0,
};

export const select: Select = {
  minChecked: 0,
  maxChecked: 0,
  variants: [{ variant: "" }],
};

export const checkbox: Checkbox = {
  minChecked: 0,
  maxChecked: 0,
  visualization: VISUALIZATION_HORIZONTAL,
  variants: [{ variant: "" }],
};

export const file: File = {
  type: FILE_TYPE_PHOTO,
  quantity: "single",
};
